import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { routerActions } from 'connected-react-router';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Chevron from '../../../Chevron';

import AccountMenuItem from '../AccountMenuItem';

import PlaceholderAvatar from './placeholder-avatar.png';
import LogoutIcon from './img_general_logout.png';

import { actionCreators as authActions } from '../../../../../redux/Auth/actions';
import { actionCreators as modalActions } from '../../../../../redux/PlanModal/actions';

import * as AppPropTypes from '../../../../../utils/propTypes';

import { TERMS_AND_CONDITIONS, PROFILE } from '../../../Routes/constants';

import styles from './styles.scss';

class AccountMenu extends Component {
  static propTypes = {
    currentUser: AppPropTypes.account,
    logout: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    openPlanModal: PropTypes.func.isRequired,
    loadAccountPlan: PropTypes.func.isRequired,
    plan: AppPropTypes.companyPlan,
  };

  static defaultProps = {
    currentUser: null,
    plan: null,
  };

  state = {
    open: false,
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick, false);
  }

  onLogout = () => {
    const { logout } = this.props;
    this.forceMenuClose();
    logout();
  };

  onTermsAndConditions = () => {
    const { push } = this.props;
    this.forceMenuClose();
    push(TERMS_AND_CONDITIONS);
  };

  onUpgrade = () => {
    const { openPlanModal, loadAccountPlan, plan } = this.props;
    this.forceMenuClose();
    if (plan) {
      openPlanModal();
    } else {
      loadAccountPlan();
    }
  };

  onProfile = () => {
    const { push } = this.props;
    this.forceMenuClose();
    push(PROFILE);
  };

  onRef = (ref) => {
    this.wrapperRef = ref;
  }

  handleClick = () => {
    const { open } = this.state;
    if (open) {
      document.removeEventListener('click', this.handleOutsideClick, false);
    } else {
      document.addEventListener('click', this.handleOutsideClick, false);
    }
    this.setState({ open: !open });
  };

  handleOutsideClick = (event) => {
    if (this.wrapperRef && this.wrapperRef.contains(event.target)) {
      return;
    }
    this.handleClick();
  };

  forceMenuClose() {
    document.removeEventListener('click', this.handleOutsideClick, false);
    this.setState({ open: false });
  }

  render() {
    const { currentUser, t } = this.props;
    if (!currentUser) {
      return null;
    }
    const { open } = this.state;
    const {
      name, role, avatar, company,
    } = currentUser;
    const userAvatar = avatar || PlaceholderAvatar;
    const canUpgrade = ['vendor', 'manufacturer'].includes(role);
    return (
      <div className={styles.wrapper} ref={this.onRef}>
        <button className={styles.header} type="button" onClick={this.handleClick}>
          <img src={userAvatar} alt="Avatar" className={styles.avatar} />
          <div className={styles.info}>
            <span className={styles.role}>
              {t(`role.${role}.name`, { company })}
            </span>
            <span className={styles.name}>
              {name}
            </span>
          </div>
          <Chevron direction={open ? 'top' : 'bottom'} />
        </button>
        <ul className={classNames(styles.menu, { [styles.open]: open })} role="navigation">
          <AccountMenuItem onClick={this.onProfile}>
            {t('account.actions.profile')}
          </AccountMenuItem>
          <AccountMenuItem icon={LogoutIcon} onClick={this.onLogout}>
            {t('account.actions.logout')}
          </AccountMenuItem>
        </ul>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.auth,
    plan: state.planModal.plan,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(authActions, dispatch),
    ...bindActionCreators(routerActions, dispatch),
    ...bindActionCreators(modalActions, dispatch),
  };
}

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
)(AccountMenu);



// WEBPACK FOOTER //
// ./src/app/components/NavigationBar/components/AccountMenu/index.js